import { all, AllEffect, ForkEffect, put, takeEvery, call, StrictEffect } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import {
  GamesActionsTypes,
  getFavouriteGamesSuccess,
  getGamesError,
  getGamesJackpotsSuccess,
  getGamesSuccess,
  getLastPlayedGamesSuccess,
} from './actions';
import { ApiResponse } from '@/models/api-response.model';
import { doNothing } from '@/utils/utils';
import bffApiService from '@/shared/bffApiService';
import {
  BffGamesResponse,
  BffGamesLastPlayedResponse,
  BffResponse,
  BffFavouriteGamesResponse,
} from '@lucky7ventures/bff-types';
import { SagaIterator } from 'redux-saga';

export function* getGamesSaga(): Generator<
  StrictEffect,
  void,
  AxiosResponse<ApiResponse<BffGamesResponse>>
> {
  try {
    const gamesResponse = yield call(bffApiService.getAllGames);

    if (gamesResponse.data.data) {
      yield put(getGamesSuccess(gamesResponse.data.data));
    }
  } catch (error) {
    yield put(getGamesError());
  }
}

export function* getLastPlayedGamesSaga(): Generator<
  StrictEffect,
  void,
  AxiosResponse<BffResponse<BffGamesLastPlayedResponse>>
> {
  try {
    const lastPlayedResponse = yield call(bffApiService.getGamesLastPlayed);
    if (lastPlayedResponse.data.data) {
      yield put(getLastPlayedGamesSuccess(lastPlayedResponse.data.data));
    }
  } catch {
    doNothing();
  }
}

export function* getFavouriteGamesSaga(): Generator<
  StrictEffect,
  void,
  AxiosResponse<BffResponse<BffFavouriteGamesResponse>>
> {
  try {
    const favouriteGamesResponse = yield call(bffApiService.getFavouriteGames);
    if (favouriteGamesResponse.data.data) {
      yield put(getFavouriteGamesSuccess(favouriteGamesResponse.data.data));
    }
  } catch {}
}

export function* getGamesJackpotsSaga(): SagaIterator {
  try {
    const response = yield call(bffApiService.getGamesJackpots);

    if (response.data.data) {
      yield put(getGamesJackpotsSuccess(response.data.data));
    }
  } catch (error) {
    yield put(getGamesError());
  }
}

export function* watchGames(): Generator<AllEffect<ForkEffect<never>>, void> {
  yield all([
    takeEvery(GamesActionsTypes.Get, getGamesSaga),
    takeEvery(GamesActionsTypes.GetLastPlayedGames, getLastPlayedGamesSaga),
    takeEvery(GamesActionsTypes.GetFavouriteGames, getFavouriteGamesSaga),
    takeEvery(GamesActionsTypes.GetGamesJackpots, getGamesJackpotsSaga),
  ]);
}
